export default __webpack_public_path__ + "static/media/logoPagesRS.7b773dd0.jpg";